import AddBrandModule from '@/modules/brand/add-brand';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/brand/add-brand/add-brand-props'
)({
  validateSearch: searchSchema,
  component: AddBrandPropsPage,
});

function AddBrandPropsPage() {
  return <AddBrandModule />;
}
